export var SearchByAccountExternalIdTypeEnum;
(function (SearchByAccountExternalIdTypeEnum) {
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_0"] = 0] = "NUMBER_0";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_1"] = 1] = "NUMBER_1";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_2"] = 2] = "NUMBER_2";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_3"] = 3] = "NUMBER_3";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_4"] = 4] = "NUMBER_4";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_5"] = 5] = "NUMBER_5";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_6"] = 6] = "NUMBER_6";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_7"] = 7] = "NUMBER_7";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_8"] = 8] = "NUMBER_8";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_9"] = 9] = "NUMBER_9";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_10"] = 10] = "NUMBER_10";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_11"] = 11] = "NUMBER_11";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_12"] = 12] = "NUMBER_12";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_13"] = 13] = "NUMBER_13";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_14"] = 14] = "NUMBER_14";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_15"] = 15] = "NUMBER_15";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_16"] = 16] = "NUMBER_16";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_17"] = 17] = "NUMBER_17";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_18"] = 18] = "NUMBER_18";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_19"] = 19] = "NUMBER_19";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_20"] = 20] = "NUMBER_20";
    SearchByAccountExternalIdTypeEnum[SearchByAccountExternalIdTypeEnum["NUMBER_21"] = 21] = "NUMBER_21";
})(SearchByAccountExternalIdTypeEnum || (SearchByAccountExternalIdTypeEnum = {}));
SearchByAccountExternalIdTypeEnum['NUMBER_0'] = 0;
SearchByAccountExternalIdTypeEnum['NUMBER_1'] = 1;
SearchByAccountExternalIdTypeEnum['NUMBER_2'] = 2;
SearchByAccountExternalIdTypeEnum['NUMBER_3'] = 3;
SearchByAccountExternalIdTypeEnum['NUMBER_4'] = 4;
SearchByAccountExternalIdTypeEnum['NUMBER_5'] = 5;
SearchByAccountExternalIdTypeEnum['NUMBER_6'] = 6;
SearchByAccountExternalIdTypeEnum['NUMBER_7'] = 7;
SearchByAccountExternalIdTypeEnum['NUMBER_8'] = 8;
SearchByAccountExternalIdTypeEnum['NUMBER_9'] = 9;
SearchByAccountExternalIdTypeEnum['NUMBER_10'] = 10;
SearchByAccountExternalIdTypeEnum['NUMBER_11'] = 11;
SearchByAccountExternalIdTypeEnum['NUMBER_12'] = 12;
SearchByAccountExternalIdTypeEnum['NUMBER_13'] = 13;
SearchByAccountExternalIdTypeEnum['NUMBER_14'] = 14;
SearchByAccountExternalIdTypeEnum['NUMBER_15'] = 15;
SearchByAccountExternalIdTypeEnum['NUMBER_16'] = 16;
SearchByAccountExternalIdTypeEnum['NUMBER_17'] = 17;
SearchByAccountExternalIdTypeEnum['NUMBER_18'] = 18;
SearchByAccountExternalIdTypeEnum['NUMBER_19'] = 19;
SearchByAccountExternalIdTypeEnum['NUMBER_20'] = 20;
SearchByAccountExternalIdTypeEnum['NUMBER_21'] = 21;
//# sourceMappingURL=SearchByAccountExternalIdTypeEnum.js.map